import { Component, OnInit } from '@angular/core';
import { CoreReviewPageRendererBaseComponent } from '../../shared/core-review-page-renderer-base.component';

@Component({
  selector: 'cu-page-review-cards',
  templateUrl: './page-review-cards.component.html'
})
export class PageReviewCardsComponent extends CoreReviewPageRendererBaseComponent implements OnInit {
  ngOnInit() {}
}
